"use client";

import { sendGTMEvent } from "@next/third-parties/google";

// GA4 ecommerce events pushed through GTM's dataLayer -- see
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce. Nesting under an
// `ecommerce` key (rather than gtag.js's flat event params) is the GTM-specific convention;
// clearing it first is Google's own documented pattern to stop a previous event's items
// bleeding into the next one.
export interface EcommerceItem {
  item_id: string;
  item_name: string;
  price: number;
  quantity?: number;
}

function ecommerceEvent(event: string, ecommerce: Record<string, unknown>) {
  sendGTMEvent({ ecommerce: null });
  sendGTMEvent({ event, ecommerce });
}

export function trackViewItem(item: EcommerceItem) {
  ecommerceEvent("view_item", { currency: "INR", value: item.price, items: [item] });
}

export function trackBeginCheckout(item: EcommerceItem) {
  ecommerceEvent("begin_checkout", { currency: "INR", value: item.price, items: [item] });
}

export function trackAddPaymentInfo(item: EcommerceItem) {
  ecommerceEvent("add_payment_info", { currency: "INR", value: item.price, items: [item] });
}

export function trackPurchase(params: { transactionId: string; value: number; item: EcommerceItem }) {
  ecommerceEvent("purchase", {
    transaction_id: params.transactionId,
    currency: "INR",
    value: params.value,
    items: [params.item],
  });
}
